import { DialogProps, Dialog as PrimeDialog } from 'primereact/dialog';
import styles from './Dialog.module.css';

export const Dialog = (props: DialogProps) => {
  const { className, ...rest } = props;
  const cls = [styles.customDialog, className].filter(Boolean).join(' ');
  return <PrimeDialog {...rest} className={cls} />;
};

export type { DialogProps };
export default Dialog;
